import { html as t, children as i, elements as s, repeat as l } from "@microsoft/fast-element";
import { toRem as o } from "../common/css-utils.js";
const v = (n) => {
  const r = t.partial(n.prefix);
  return t`
    <div
      class="control"
      part="control"
      @mouseleave="${(a) => a.handleRatingStarMouseLeave()}"
    >
      <div
        class="rating-stars"
        ${i({
    property: "stars",
    filter: s(`${r}-icon`)
  })}
      >
        ${l(
    [1, 2, 3, 4, 5],
    () => t`
          <${r}-icon
            class="rating-star ${(a, e) => !e.parent.actionable && a > e.parent.value && !(e.parent.value === 0 && a === 1) ? "hidden" : ""}
            ${(a, e) => a <= e.parent.value ? "rating-star-active" : ""}"
            name="star"
            size="${o(1)}"
            @click="${(a, e) => e.parent.handleRatingStarClick(a)}"
            @mouseover="${(a, e) => e.parent.handleRatingStarMouseOver(a)}"
          ></${r}-icon>
        `
  )}
      </div>
      <div class="rating-info">
        <span class="rating-value">${(a) => a.renderedValue}</span>/5
      </div>
    </div>
  `;
};
export {
  v as ratingTemplate
};
